export const fileToBase64 = (file: File | Blob | ArrayBuffer): Promise<string> =>
  new Promise((resolve, reject) => {
    if (!file) {
      return resolve('');
    }

    if (
      !(file instanceof ArrayBuffer) &&
      !(file instanceof Blob) &&
      typeof file === 'object' &&
      Object.keys(file).length === 0
    ) {
      return resolve('');
    }

    // if data is arraybuffer, convert to blob first
    if (file instanceof ArrayBuffer) {
      file = new Blob([file]);
    }

    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result as string);
    };

    reader.readAsDataURL(file);
    reader.onerror = reject;
  });
